import React from 'react';
import { AlertCircle, WifiOff } from 'lucide-react';
import './StatusNotice.css';

export default function StatusNotice({ children, retrying = false, action, actionLabel = 'Retry', className = '' }) {
  const Icon = retrying ? WifiOff : AlertCircle;
  return <div className={`status-notice ${retrying ? 'status-notice-retrying' : 'status-notice-error'} ${className}`} role={retrying ? 'status' : 'alert'}>
    <Icon size={17} aria-hidden="true" />
    <span className="status-notice-copy">{children}</span>
    {action && <button type="button" onClick={action}>{actionLabel}</button>}
  </div>;
}
